export type TicketAction =
  | { type: 'SET_TICKET_SUMMARY', ticketSummary: Julius.Website.TicketSummaryViewModel }
  | { type: 'SET_IS_FETCHING_TICKET' }
  | { type: 'SET_FETCH_TICKET_FAILED' }
  | { type: 'SET_TICKET_NOT_FOUND' };

export const setTicketSummary = (ticketSummary: Julius.Website.TicketSummaryViewModel): TicketAction => ({
  ticketSummary,
  type: 'SET_TICKET_SUMMARY',
});

export const setIsFetching = (): TicketAction => ({
  type: 'SET_IS_FETCHING_TICKET',
});

export const setFetchFailed = (): TicketAction => ({
  type: 'SET_FETCH_TICKET_FAILED',
});

export const setTicketNotFound = (): TicketAction => ({
  type: 'SET_TICKET_NOT_FOUND',
});


// WEBPACK FOOTER //
// ./src/pages/TicketPage/Redux/actions.tsx